export const TOGGLE_GROUP = 'TOGGLE_GROUP';
export const EXPAND_GROUP = 'EXPAND_GROUP';



// WEBPACK FOOTER //
// ./js/actions/ToggleGroup.js